import React from "react";
import styles from "./small-blueprint-banner-auto-match.module.scss";
import { ButtonWithIcon } from "@components/atoms/buttons/button-with-icon/button-with-icon";
import magnifyingGlassDarkIcon from "@src/assets/svg/magnifying-glass-dark.svg";
import uploadIcon from "@src/assets/svg/upload-icon.svg";
import uploadIconDisabled from "@src/assets/svg/upload-icon-disabled.svg";
import {
  updateShowAutoMatchBlueprintModal,
  updateShowMyBlueprintLibraryModal,
  updateShowSaveBlueprintModal,
} from "@src/reducers/your-reducer";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { ColoredGradientBorderContainer } from "@src/components/templates/layouts/colored-gradient-border-container/colored-gradient-border-container";
import { AutoMatchBlueprintButton } from "@src/components/atoms/auto-match-blueprint-button/auto-match-blueprint-button";
import { useI18N } from "@src/language/language-context";
import { RenderIfUserHasPermission } from "@src/components/molecules/render-if-user-has-permission/render-if-user-has-permission";

const cssClassName = "small-blueprint-banner-auto-match";

export const SmallBluePrintBannerAutoMatch = () => {
  const dispatch = useDispatch();
  const i18n = useI18N();

  const transferedNodeData = useSelector(
    (state: RootState) => state.yourSlice.editStructurePageTransferData,
  );

  const texts = {
    smallOrangeText: i18n(
      "modules.smallBlueprintBannerAutoMatch.smallOrangeText",
    ),
    gradientText: i18n("modules.smallBlueprintBannerAutoMatch.gradientText"),
    autoMatchBlueprintButton: i18n(
      "modules.smallBlueprintBannerAutoMatch.autoMatchBlueprintButton",
    ),
    myBlueprintLibraryButton: i18n(
      "modules.smallBlueprintBannerAutoMatch.myBlueprintLibraryButton",
    ),
    saveBlueprintButtonText: i18n(
      "modules.smallBlueprintBannerAutoMatch.saveBlueprintButton",
    ),
  };

  const checkStateAndReturnBoolean = (value) => {
    return value ? true : false;
  };

  const checkStateAndReturnVariant = (value) => {
    return value ? "secondary-disabled" : "secondary";
  };

  const checkStateAndReturnIcon = (value) => {
    return value ? uploadIconDisabled : uploadIcon;
  };

  const handleOpenMyBlueprintLibrary = () => {
    dispatch(updateShowMyBlueprintLibraryModal(true));
  };
  const handleSaveBlueprints = () => {
    dispatch(updateShowSaveBlueprintModal(true));
  };

  const handleAutoMatchBlueprint = () => {
    dispatch(updateShowAutoMatchBlueprintModal(true));
  };

  return (
    <>
      <ColoredGradientBorderContainer>
        <div className={styles[cssClassName]}>
          <div className={styles[`${cssClassName}__inner-wrapper`]}>
            <div className={styles[`${cssClassName}__text-wrapper`]}>
              <p className={styles[`${cssClassName}__small-orange-text`]}>
                {texts.smallOrangeText}
              </p>
              <p className={styles[`${cssClassName}__gradient-text`]}>
                {texts.gradientText}
              </p>
            </div>
            <div className={styles[`${cssClassName}__button-wrapper`]}>
              <AutoMatchBlueprintButton
                fun={handleAutoMatchBlueprint}
                text={texts.autoMatchBlueprintButton}
              />
              <ButtonWithIcon
                fun={handleOpenMyBlueprintLibrary}
                text={texts.myBlueprintLibraryButton}
                icon={magnifyingGlassDarkIcon}
              />
              <RenderIfUserHasPermission permission={"manage-blueprints"}>
                <ButtonWithIcon
                  variant={[checkStateAndReturnVariant(!transferedNodeData)]}
                  fun={handleSaveBlueprints}
                  text={texts.saveBlueprintButtonText}
                  icon={checkStateAndReturnIcon(!transferedNodeData)}
                  disabled={checkStateAndReturnBoolean(!transferedNodeData)}
                />
              </RenderIfUserHasPermission>
            </div>
          </div>
        </div>
      </ColoredGradientBorderContainer>
    </>
  );
};
